import { Link } from "react-router-dom";

const TermsOfService = () => {
  return (
    <article>
      <p>Aktualisiert: 22.04.2026</p>

      <p>
        <strong>1. Betreiber und Geltungsbereich</strong>
      </p>
      <ul>
        <li>
          Diese Nutzungsbedingungen gelten für die Webseite{" "}
          <strong>Surfanzeigen</strong>, erreichbar unter{" "}
          <Link to="https://www.surfanzeigen.de">www.surfanzeigen.de</Link>,
          betrieben von Jonathan Patzwaldt, Moltkestr. 23. Mit "Konto" ist das
          passwortgeschützte Nutzerkonto gemeint. "Besucher" sind natürliche
          Personen ohne Konto. "Nutzer" sind natürliche Personen mit Konto.
          "Anzeige" bezeichnet einen Eintrag mit einem Angebot. "Ware"
          bezeichnet die in der Anzeige beschriebenen Gegenstände.
        </li>
        <li>
          Mit der Nutzung der Plattform akzeptierst du diese Nutzungsbedingungen
          in ihrer jeweils aktuellen Fassung.
        </li>
      </ul>

      <p>
        <strong>2. Nutzungsberechtigung</strong>
      </p>
      <ul>
        <li>
          Die Nutzung der Plattform ist ausschließlich natürlichen Personen ab
          18 Jahren gestattet. Das Anlegen eines Kontos als juristische Person
          ist untersagt.
        </li>
        <li>
          Gewerbliche Angebote oder Verkäufe sind derzeit nicht gestattet. Bei
          Interesse an einer gewerblichen Nutzung kontaktiere uns unter{" "}
          <a href="mailto:kontakt@surfanzeigen.de">kontakt@surfanzeigen.de</a>.
        </li>
      </ul>

      <p>
        <strong>3. Pflichten der Nutzer</strong>
      </p>
      <ul>
        <li>
          Jegliche Form von Spam, automatisierten Masseneingaben oder Missbrauch
          der Eingabemasken ist ausdrücklich verboten.
        </li>
        <li>
          Beleidigende, diskriminierende, pornografische oder betrügerische
          Inhalte sind nicht gestattet.
        </li>
        <li>
          Nutzer verhalten sich gegenüber anderen Mitgliedern freundlich,
          ehrlich und fair.
        </li>
        <li>
          Das bewusste Verschweigen bekannter Mängel an der angebotenen Ware ist
          untersagt.
        </li>
        <li>
          Nutzer sind verpflichtet, Verstöße gegen diese Nutzungsbedingungen
          umgehend dem Betreiber zu melden.
        </li>
        <li>
          Nutzer dürfen keine Inhalte einstellen, an denen sie keine Rechte
          besitzen, insbesondere keine urheberrechtlich geschützten Bilder
          Dritter.
        </li>
      </ul>

      <p>
        <strong>4. Privatverkauf und Gewährleistung</strong>
      </p>
      <ul>
        <li>
          Alle Transaktionen auf dieser Plattform sind Privatverkäufe zwischen
          Nutzern. Der Betreiber ist kein Vertragspartner dieser Transaktionen.
        </li>
        <li>
          Bei Privatverkäufen kann die gesetzliche Gewährleistung vertraglich
          ausgeschlossen werden. Käufer sollten die Ware vor dem Kauf sorgfältig
          prüfen.
        </li>
        <li>
          Der Betreiber übernimmt keine Haftung für die Richtigkeit der
          Anzeigen, die Qualität der Ware oder das Verhalten der Nutzer.
        </li>
      </ul>

      <p>
        <strong>5. Haftungsausschluss des Betreibers</strong>
      </p>
      <ul>
        <li>
          Der Betreiber haftet nicht für Schäden, die durch die Nutzung der
          Plattform entstehen, insbesondere nicht für Schäden aus Transaktionen
          zwischen Nutzern, es sei denn, der Betreiber handelt vorsätzlich oder
          grob fahrlässig.
        </li>
        <li>
          Der Betreiber übernimmt keine Haftung für vorübergehende
          Nichtverfügbarkeit der Plattform.
        </li>
        <li>
          Für externe Links auf dieser Plattform übernimmt der Betreiber keine
          Haftung.
        </li>
      </ul>

      <p>
        <strong>6. Kontolöschung und Sperrung</strong>
      </p>
      <ul>
        <li>
          Nutzer können ihr Konto jederzeit in den Kontoeinstellungen löschen.
          Mit der Löschung werden alle personenbezogenen Daten gemäß unserer{" "}
          <Link to="/datenschutz">Datenschutzerklärung</Link> gelöscht.
        </li>
        <li>
          Verstöße gegen diese Nutzungsbedingungen können zur vorübergehenden
          Sperrung oder zum dauerhaften Ausschluss von der Plattform führen. Zur
          Betrugsprävention behalten wir uns das Recht vor, relevante Daten zu
          speichern; siehe hierzu unsere{" "}
          <Link to="/datenschutz">Datenschutzerklärung</Link>.
        </li>
        <li>Konten werden nach 12 Monaten Inaktivität automatisch gelöscht.</li>
      </ul>

      <p>
        <strong>7. Änderungen der Nutzungsbedingungen</strong>
      </p>
      <ul>
        <li>
          Der Betreiber behält sich das Recht vor, diese Nutzungsbedingungen
          jederzeit anzupassen. Registrierte Nutzer werden über wesentliche
          Änderungen per E-Mail informiert. Die weitere Nutzung der Plattform
          nach Inkrafttreten der Änderungen gilt als Zustimmung.
        </li>
      </ul>

      <p>
        <strong>8. Anwendbares Recht und Gerichtsstand</strong>
      </p>
      <ul>
        <li>Es gilt deutsches Recht unter Ausschluss des UN-Kaufrechts.</li>
        <li>
          Gerichtsstand für Streitigkeiten mit dem Betreiber ist Lübeck, soweit
          gesetzlich zulässig.
        </li>
      </ul>
    </article>
  );
};

export default TermsOfService;
